import { GetServerSideProps, InferGetServerSidePropsType } from 'next';
import { fetchWebAPINavigation, fetchWebAPIServerDataHandler } from '@/lib/fetcher';
import HeadMetaTag from '@/components/metatags/HeadMetaTag';
import React from 'react';
import OfertaIndex from '@/features/oferta/OfertaIndex/OfertaIndex';
import CustomError from '@/features/errors';
import AppProvider from '@/context/AppProvider';
import fetchMessages from '@/fetchMessages';

export const getServerSideProps: GetServerSideProps = async ({ req, query, ...rest }) => {
  const { locale, messages } = await fetchMessages(rest.locale as string);

  const qs = locale ? `?locale=${locale}` : ``;
  const path = `/ofertas${qs}`;
  const [navigation, pageProps] = await Promise.all([
    fetchWebAPINavigation({ locale }),
    fetchWebAPIServerDataHandler(path, 'OFERTAS INDEX', req),
  ]);
  const { props, notFound, redirect } = pageProps;
  if (notFound !== undefined) return { notFound: true };
  if (redirect !== undefined) return { redirect };
  if (props !== undefined) return { props: { ...props, navigation, messages } };

  return {
    props: {
      data: null,
    },
  };
};

export default function Ofertas({ data, error, ...props }: InferGetServerSidePropsType<GetServerSideProps>) {
  if (error) {
    return <CustomError error={error} />;
  }
  const { meta } = data.page;
  return (
    <AppProvider navigation={props.navigation}>
      <HeadMetaTag meta={meta} />
      <OfertaIndex data={data} />
    </AppProvider>
  );
}
